/**
 * Decide whether to render the animated cosmic hero or the static fallback.
 * Returns false when the user prefers reduced motion / data, the device is
 * resource-constrained, or save-data is on.
 */
export function shouldAnimate(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (window.matchMedia('(prefers-reduced-data: reduce)').matches) return false;
    const conn = navigator.connection;
    if (conn?.saveData === true) return false;
    if ((navigator.hardwareConcurrency ?? 8) < 4) return false;
  } catch {
    /* ignore — default to animating */
  }
  return true;
}
